import React from "react";
import PropTypes from "prop-types";  // Import PropTypes
import Navbar from "../Componant/Navbar/Navbar";
import PoweredBy from "../Componant/PoweredBy/PoweredBy";
import bgImg from "../Assets/homeBgImg.jpg";

export default function HomeLayout({ page }) {
  return (
    <div>
      <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
        <Navbar />
      </div>
      <div
        style={{
          textAlign: "center",
          background: {bgImg},
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: "100vh",
          position: "relative", // To allow positioning within the container
        }}
      >
        {page}
      </div>
      <div
        style={{
          position: "fixed",
          bottom: "10px",
          left: "50%",
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",
        }}
      >
        <PoweredBy />
      </div>
    </div>
  );
}

// Add PropTypes validation for 'page'
HomeLayout.propTypes = {
  page: PropTypes.node.isRequired,  // 'page' should be a React node (any valid JSX)
};
